import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import RevenueTable from "./revenueTable";
import { actionCreators } from "../redux/multiLocationSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

export default function RevenueTableHeader() {
  const dispatch = useDispatch();

  const allRevenue = useSelector((state) => state.multiLocation.allRevenue);
  const { filters, value } = useSelector((state) => state.multiLocation.secondaryRevenueType);
  const revenueTableLoading = useSelector((state) => state.multiLocation.revenueTableLoading);

  const { secondary_revenue_mom_total, revenue_mom_total } = allRevenue;
  let membershipMoMTotalClass, revenueMoMTotalClass;

  if (secondary_revenue_mom_total && secondary_revenue_mom_total.indexOf("-") > -1) {
    membershipMoMTotalClass = "negative";
  } else {
    membershipMoMTotalClass = "positive";
  }

  if (revenue_mom_total && revenue_mom_total.indexOf("-") > -1) {
    revenueMoMTotalClass = "negative";
  } else {
    revenueMoMTotalClass = "positive";
  }

  return (
    <section className="section-table">
      <div className="table-wrapper-top">
        <div className="table-top total-revenue">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title" style={{ paddingTop: "10px" }}>
              <h2>Total Revenue</h2>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{allRevenue.revenue_total}</span>
                    {allRevenue.revenue_mom_total !== "0.0%" ? (
                      <span className={`percent ${revenueMoMTotalClass}`}>
                        {allRevenue.revenue_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous: <span>{allRevenue.revenue_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average: <span>{allRevenue.revenue_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-top membership-revenue">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <div className="membership-revenue__dropdown">
                <MultiSelectDropdown
                  options={filters}
                  includeFilter={false}
                  selectedFilters={value}
                  onSelectChange={(data) =>
                    dispatch(actionCreators.updateSecondaryRevenueType(data))
                  }
                />
              </div>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{allRevenue.secondary_revenue_total}</span>
                    {allRevenue.secondary_revenue_mom_total !== "0.0%" ? (
                      <span className={`percent ${membershipMoMTotalClass}`}>
                        {allRevenue.secondary_revenue_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous:&nbsp;
                  <span>{allRevenue.secondary_revenue_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average:&nbsp;
                  <span>{allRevenue.secondary_revenue_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wrapper revenue-table">
        {revenueTableLoading ? <LoadingAnimation /> : <RevenueTable />}
      </div>
    </section>
  );
}
